module.exports = __webpack_public_path__ + "img/no-vehicwle-icon.7017ac80.jpg";